import { render } from "./onePerformer.vue?vue&type=template&id=0a4ed42e"
const script = {}

import "./onePerformer.vue?vue&type=style&index=0&id=0a4ed42e&lang=css"

import exportComponent from "/var/www/turkey-25/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__